import React from 'react';
import { domToReact } from 'html-react-parser';
import ResourcesTile from '../../../../../components/Molecules/ResourcesTile';
import LearningCenterSourceIdLink from '../../../../../components/Molecules/LearningCenterSourceIdLink';
import {wpClassNames} from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';
import findDomElement, {findDomElementFilterFn} from '../../../../findDomElement';

export const extractElementProps = ( anchorNode, replaceFn ) =>
{
    if ( !anchorNode?.attribs ) return null;
    const { attribs, children } = anchorNode;
    const url = attribs['data-href'];
    const {rel} = attribs;
    const {target} = attribs;
    let buttonIcon = null;
    let title = null;
    let subtitle = null;
    let blushIllustration = null;
    let blushIllustrationAlt = null;
    let buttonAttributes = null;

    const blushChild = children.find(
        child => child.name === 'div' &&
            child.attribs.class?.includes( wpClassNames.BLUSH )
    )

    if ( blushChild )
    {
        blushIllustration = blushChild.attribs?.['data-url'];
        blushIllustrationAlt = blushChild.attribs?.['aria-label']
    }

    let mobileTextContainer = children.find(
        child => child?.attribs?.class?.includes('mobiletextcontainersignal')
    )

    const titleH3 = findDomElement({ element: children[1]?.children?.filter(child => child.type === "tag")?.at(0), targetName: 'h3' })
    if ( titleH3 )
    {
        title = domToReact( titleH3.children, replaceFn() )
    }

    const subtitleSmall = findDomElement({ element: children[1]?.children?.filter(child => child.type === "tag")?.at(1), targetName: 'small' })
    if ( subtitleSmall )
    {
        subtitle = domToReact( subtitleSmall.children, replaceFn() )
    }

    if (!mobileTextContainer)
    {
        mobileTextContainer = children.find(
            child => child?.attribs?.class?.includes('rowtwosignal')
        )
        if (mobileTextContainer)
            mobileTextContainer = mobileTextContainer.children.find(
                child => child?.attribs?.class?.includes('mobiletextcontainersignal')
            )
    }
    
    if (mobileTextContainer)
    {
        const subtitleChild = mobileTextContainer.children.find(
            child => child?.attribs?.class?.includes('subtitlesignal')
        )
        if ( subtitleChild )
        {
            subtitle = domToReact( subtitleChild.children, replaceFn() )
        }
    }

    const svgChild = children.find(
        child => child.attribs?.role === 'button'
    )
        ?.children
        ?.find(
            child => child.name === 'span'
        )

    if ( svgChild )
    {
        buttonIcon = (svgChild.children.length) ? domToReact(svgChild.children, replaceFn()) : null;
    }

    const filterFn = (element) =>
    {
        if (element?.attribs?.role === 'button' && element?.name === 'span')
        {
            buttonAttributes = {...buttonAttributes, 'aria-label': element?.attribs["aria-label"] }
            return true;
        }  
        return false;
    };
    children.map( item => findDomElementFilterFn({ element: item, filterFn }) )

    return {
        buttonIcon,
        url,
        title,
        subtitle,
        blushIllustration,
        blushIllustrationAlt,
        rel: rel || null,
        target: target || null,
        buttonAttributes,
    }
}

const toResourcesTile = (parserData) =>
{
    const { parserOptions: {replaceFn} } = parserData
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs, 
        children = parserPropTypesDefaults.children
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'div' ) return null;
        if (!attribs?.class || !attribs?.class.includes(wpClassNames.WRAPPER)) return null;
        const wrapperRE = new RegExp(`${wpClassNames.WRAPPER}( |$)`);
        if ( !wrapperRE.test(attribs.class) ) return null;

        const parsedProps = extractElementProps(
            children.find( child => child.type === 'tag' && child.name === 'a' )
            , replaceFn );
        const { articleId, articleSourceId, moid } = parserData;
        const props = {
            ...parsedProps,
            LinkComponent: LearningCenterSourceIdLink,
            articleId,
            ...(articleSourceId ? {articlesourceid: articleSourceId} : undefined), // Lowercase DOM custom attribute for React to recognize
            moid
        }

        return (
            <ResourcesTile {...props} />
        )
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;

}
export default toResourcesTile;
